<template>
  <v-menu
      ref="menu"
      v-model="menuDataPicker"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="dates"
      transition="scale-transition"
      offset-y
      min-width="290px">
    <template v-slot:activator="{ on }">
      <v-combobox
          v-model="formattedData"
          multiple
          chips
          :error="hasErrors"
          small-chips
          :label="label"
          prepend-icon="event"
          readonly
          :error-messages="errorMessages"
          :append-icon="!readonly && value && value.length > 0
            ? 'clear'
            : null"
          @click:append="clear"
          v-on="on" />
    </template>
    <v-date-picker
        v-model="dates"
        multiple
        no-title
        scrollable
        :locale="controlLocale"
        :first-day-of-week="1"
        :min="minDate"
        :max="maxDate">
      <v-spacer />
      <v-btn
          id="cancelDateBtn"
          text
          color="primary"
          @click.stop="menuDataPicker = false">
        {{ $t('Отмена') }}
      </v-btn>
      <v-btn
          id="selectDateBtn"
          text
          color="primary"
          @click.stop="saveDate">
        {{ $t('Выбрать') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: String,
      errorMessages: Array,
      minSelectedDate: {
        type: String,
        default: '1991-01-01'
      },
      maxSelectedDate: {
        type: String
      }
    },
    data () {
      return {
        menuDataPicker: false,
        dates: []
      }
    },
    computed: {
      formattedData () {
        const vm = this
        return vm.dates
          ? vm.dates.map(d =>
            d
              ? vm.$moment(d).format('DD.MM.YYYY')
              : '')
          : []
      },
      hasErrors () {
        return this.errorMessages && this.errorMessages.length > 0
      },
      minDate () {
        return this.$moment(this.minSelectedDate).format('YYYY-MM-DD')
      },
      maxDate () {
        return this.maxSelectedDate
          ? this.$moment(this.maxSelectedDate).format('YYYY-MM-DD')
          : this.$moment(this.$moment().add(10, 'years')).format('YYYY-MM-DD')
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newValue) {
          if (newValue) { this.dates = newValue }
        }
      }
    },
    methods: {
      saveDate: function () {
        this.$refs.menu.save(this.dates)
        this.updateValue()
      },
      updateValue: function () {
        if (!this.dates) {
          return
        }
        // let newDateTime = this.$moment(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.$emit('input', this.dates)
      },
      clear: function () {
        this.dates = []
        this.$emit('input', [])
      }
    }
  }
</script>
